const timeline = {
  btnReset: 'Zurücksetzen',
  edit: 'Bearbeiten',
  filters: {
    status: {
      placeholder: 'Status',
      options: {
        'new': 'Neu',
        'in-route': 'Unterwegs',
        'sent': 'Gesendet',
        'approved': 'Genehmigt',
        'done': 'Erledigt',
        'canceled': 'Storniert',
        'picking_up': 'Abholung',
      },
    },
    driver: 'Fahrer',
    vehicle: 'Fahrzeug',
    areas: 'Zonen',
    locations: 'Standardstandorte',
    airportLocations: 'Flughafenstandorte',
    attributes: 'Attribut',
    driverShifts: 'Fahrerschichten anzeigen',
    showUnassignedTrips: 'Nicht zugewiesene Fahrten anzeigen',
  },
  totals: {
    assigned: 'Zugewiesen',
    unassigned: 'Nicht zugewiesen',
  },
  alerts: {
    etaChanged: 'Die voraussichtliche Ankunftszeit an den Haltestellen {{stopsIds}} der Fahrt {{tripId}} wurde aktualisiert - der Fahrer wurde vom System benachrichtigt.',
  },
  assigenModal: {
    header: 'Fahrer zuweisen',
    description: 'Bitte wählen Sie einen Fahrer/ein Fahrzeug aus der Liste unten aus',
    driver: 'Fahrer auswählen',
    vehicle: 'Fahrzeug auswählen',
    button: 'Zuordnen',
  },
  toast: {
    toastSomethingWasWrong: 'Irgendetwas stimmte nicht',
    assignedTrips: '{{numOfTrips}} Fahrten wurden zugewiesen',
  },
  empty: 'Keine Fahrten in den letzten 24 Stunden',
  driverAndVehicle: 'Fahrer & Fahrzeug',
  driverInfo: {
    phoneNumber: 'Telefonnummer',
    lettersLeft: 'Buchstaben übrig',
    sendMessage: 'Nachricht senden',
  },
  actions: {
    manualAssign: 'Manuelle Zuweisung',
    removeAssign: 'Zuweisung entfernen',
    assignInsights: 'Erkenntnisse zuweisen',
  },
  tripInformation: {
    trip: 'Fahrtenummer {{id}}',
  },
  stopInfo: {
    stopNumber: 'Haltestelle #{{number}}',
    tripId: 'Fahrt: {{id}}',
    pta: 'PTA: {{pta}}',
    eta: 'ETA: {{eta}}',
    totalReservations: '{{count}} Reservierungen',
    pickupReservations: '{{count}} Abholungen',
    dropReservations: '{{count}} Absetzstellen',
    totalSeats: '{{count}} Sitze',
    table: {
      header: {
        reqAppt: 'Anfr./Termin',
        passenger: 'Passagier',
        bookingId: 'Buchungs-ID',
        seats: 'Sitze',
        zones: 'Zonen',
        attributes: 'Attribute',
      },
      sections: {
        pickups: 'ABHOLUNGEN',
        dropoffs: 'AUSSTIEGE',
        request: 'Anfrage',
        appt: 'Termin',
      },
    },
  },
};

export default timeline;
